import { Navigate } from "react-router-dom";
import LoadingScreen from "../Loading/LoadingScreen.tsx";
import { useUserQuery } from "../../hooks/useUserQuery";
import type { ReactElement } from "react";

const ProtectedRoute = ({ children }: any): ReactElement | null => {

  const { data: user, isLoading } = useUserQuery();

  if (isLoading) {
    return <LoadingScreen fullScreen={true} />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children as ReactElement;
};

export default ProtectedRoute;
